import { ENV_KEY } from '../constants';
/**
 * 私有存储，闭包保护，外部无法直接访问
 */
const defaultStore = {
    env: () => '',
    baseUrl: () => '',
    token: () => '',
    debug: () => false,
    loginUrl: () => ''
};
const privateStore = Object.fromEntries(Object.keys(defaultStore).map(key => [key, defaultStore[key]]));
const resolvedEnvProxy = {};
for (const key of Object.keys(privateStore)) {
    Object.defineProperty(resolvedEnvProxy, key, {
        get: () => privateStore[key](),
        enumerable: true,
        configurable: false
    });
}
/**
 * 初始化环境变量
 * 在 globalThis 上创建只读的 env 对象，值被私有化保护
 * @param values 环境变量键值对
 */
export const initEnv = (values) => {
    checkEnv(values);
    // 存入私有存储，所有字段均为 getter 函数
    Object.assign(privateStore, values);
    // 如果已经定义过 env，跳过
    if (Object.prototype.hasOwnProperty.call(globalThis, ENV_KEY)) {
        return;
    }
    // 构建属性描述符：每个 key 都是只读 getter，不可枚举、不可配置
    const descriptors = {};
    for (const key of Object.keys(privateStore)) {
        descriptors[key] = {
            get: () => privateStore[key](),
            enumerable: false,
            configurable: false
        };
    }
    // 创建一个冻结的代理对象作为 env
    const envProxy = Object.create(null);
    Object.defineProperties(envProxy, descriptors);
    Object.freeze(envProxy);
    // 将 env 挂载到 globalThis，且不可修改、不可删除
    Object.defineProperty(globalThis, ENV_KEY, {
        value: envProxy,
        writable: false,
        enumerable: false,
        configurable: false
    });
};
export function getEnv(key) {
    if (key) {
        return privateStore[key]();
    }
    return resolvedEnvProxy;
}
export const checkEnv = (values) => {
    // 判断 defaultStore的 必填字段 是否配置就可以，不用判断值是否为空
    const errors = [];
    Object.keys(defaultStore).forEach(key => {
        if (defaultStore[key] && !Object.prototype.hasOwnProperty.call(values, key)) {
            errors.push(`${key} 未配置`);
        }
    });
    if (errors.length > 0) {
        throw new Error('初始化环境变量失败，请检查环境变量配置是否正确：\n' + errors.join(', ') + '\n');
    }
};
